const routes = [
    // {
    //     path: "/myProfile",
    //     component: () => import("../pages/Index"),
    //     name: "myProfileIndex",
    //     meta: {
    //         isAuthenticated: true,
    //         //permission: ""
    //     }
    // },
    {
        path: "/graduate-profile",
        component: () => import("../pages/detail/Index"),
        name: "myProfileDetailIndex",
        meta: {
            isAuthenticated: true,
            //permission: ""
        }
    },

];

export default routes;
